import { NavLink } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';

import { RouteList } from '@/shared/constants';
import { useProjectPath } from '@/shared/projects/project-path';

import styles from './sidebar-list.module.scss';

export const SidebarList = () => {
  const { pathname } = useLocation();
  const withProject = useProjectPath();

  const items = [
    {
      label: 'Книги',
      path: withProject(RouteList.BOOKS),
    },
    {
      label: 'Категории',
      path: withProject(RouteList.CATEGORIES),
    },
    {
      label: 'Авторы',
      path: withProject(RouteList.AUTHORS),
    },
    {
      label: 'Издательства',
      path: withProject(RouteList.PUBLISHERS),
    },
  ];

  return (
    <nav>
      <ul>
        {items.map(({ path, label }) => (
          <NavLink
            classNames={{
              root: styles.linkRoot,
              label: styles.link,
            }}
            key={path}
            label={label}
            component={Link}
            active={pathname === path}
            to={path}
          />
        ))}
      </ul>
    </nav>
  );
};
